import { Link, useLocation } from "react-router-dom";

export function Sidebar({ className = '' }) {
  const location = useLocation();
  const menuItems = [
    { name: 'Link', icon: '/images/LINK.svg', path: '/' },
    { name: 'Image Gallery', icon: '/images/IMAGE GALLERY.svg', path: '/tabgallery' },
    { name: 'PDF File', icon: '/images/PDF FILE.svg', path: '/tabpdf' },
    { name: 'Event Forms', icon: '/images/EVENT FORMS.svg', path: '/tabeventforms' },
    { name: 'Restaurant Menu', icon: '/images/RESTURANT MENU.svg', path: '/tabrestaurantmenu' },
    { name: 'Products Store', icon: '/images/PRODUCTS STORE.svg', path: '/tabproductsstore' },
    { name: 'Bio', icon: '/images/BIO.svg', path: '/tabbio' },
    { name: 'WiFi', icon: '/images/WI-Fcopy.png', path: '/tabwi-fi' },
  ];

  return (
    <aside
      className={`
        lg:w-[300px] w-[165px] bg-white uppercase   
        ${className}
      `}
    >
      <nav>
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={index}
              to={item.path}
              className={`
                flex items-center helvetica-neue !leading-[1.2] gap-1 lg:gap-3
                p-2 sm:p-4  !tracking-normal 
                lg:pl-10 lg:pr-3 lg:py-6
                border-b-2 !font-normal  
                !text-[11px]  lg:!text-lg 
                ${isActive
                  ? 'bg-[#F47321] text-white font-light'
                  : 'text-black hover:bg-gray-100'
                }
              `}
            >
              <img
                src={item.icon}
                alt={item.name}
                className={`
                  w-[1.5rem] h-[1.5rem] ml-2 lg:w-9 lg:h-9 mr-1 sm:mr-2 transition tracking-wide font-light
                  ${isActive ? 'filter invert brightness-0' : ''}
                `}
              />
              <span className="truncate">{item.name}</span>
              
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
